<template>
  <card class="no-border-card card-instructions">
    <template slot="header">
      <h3>Attachments</h3>
    </template>
      <ul class="list-steps">
        <li v-for="(attachment, index) in attachments" :key="attachment.id">
          <span class="steps">{{ ++index }}</span>

          <a :href="`${attachment.attachment.absoluteUri}`"  target='_blank'>{{ attachment.attachment.name }}</a>
        </li>
      </ul>
  </card>
</template>
<script>

  export default {
    title: "recipe-attachments",
    props: ['recipeData'],
    data() {
      return {
      }
    },
    computed: {
      attachments() {
        if(this.recipeData.recipeAttachments){
          return this.recipeData.recipeAttachments.slice().sort((a,b) => {
            return a.sortOrder - b.sortOrder
          })
        }
        return [];
      }
    },
    methods: {
      onCreated() {
      }
    },
    created(){
      this.onCreated();
    },
    mounted() {
    },
    watch: {
      $route(to, from) {
        this.onCreated();
      }
    }
  }
</script>
<style></style>
